export default __webpack_public_path__ + "static/iot_1-90c974bad2961e01ddab50b8146fa38d.jpg";